"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Product = require("./Product");

var _Product2 = _interopRequireDefault(_Product);

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TicketChangeModel = function (_Observer) {
    _inherits(TicketChangeModel, _Observer);

    /**
     * Tarifprodukt
     * @type {Product}
     */
    function TicketChangeModel(observers, id, request) {
        _classCallCheck(this, TicketChangeModel);

        var _this = _possibleConstructorReturn(this, (TicketChangeModel.__proto__ || Object.getPrototypeOf(TicketChangeModel)).call(this, observers, id, request));

        _this.TariffProduct = new _Product2.default();

        _this.ContractId = "";

        return _this;
    }

    //#region

    /**
     * Id des Vertrags
     * @type {string}
     */


    _createClass(TicketChangeModel, [{
        key: "ContractChangeTicket",
        value: function ContractChangeTicket() {
            var me = this;

            var sendData = {
                ContractId: me.ContractId,
                TariffProduct: me.TariffProduct
            };

            this.request.setRequest("/contracts/changeTicket");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("PUT");
            this.request.setCallback(function (result) {
                var id = me.Id ? me.Id : "ChangeTicket";
                me.Notify(id);
            });

            this.request.doRequest();
        }

        //#endregion

    }]);

    return TicketChangeModel;
}(_Observer3.default);

exports.default = TicketChangeModel;